// Supabase intentionally returns an obfuscated user with no identities for
// existing-account signUp attempts. A successful HTTP response is not a signup.
export function isGenuineEmailSignup(
  user: { id?: string; identities?: unknown[] } | null | undefined
): boolean {
  return Boolean(user?.id && user.identities?.length);
}
